import { z } from 'zod';
import { FlowDefinitionForListSchema, FlowDefinitionWithFlowSchema } from './flowDefinition.js';
import { GetFlowDefinitionByIdParamsSchema, ListFlowDefinitionsQuerySchema, } from './flowDefinitionRequests.js';
const TAGS = ['FlowDefinition'];
export const FLOW_DEFINITIONS_BASE_ROUTE = '/flow-definitions';
export const FlowDefinitionCreateRoute = {
    method: 'post',
    fullPath: FLOW_DEFINITIONS_BASE_ROUTE,
    summary: 'Create a flow definition',
    tags: TAGS,
};
export const FlowDefinitionListRoute = {
    method: 'get',
    fullPath: FLOW_DEFINITIONS_BASE_ROUTE,
    summary: 'List flow definitions',
    description: 'Lists flow definitions the caller can access, optionally filtered by flow, agent, organization, lifecycle state, or creation date.',
    tags: TAGS,
    query: ListFlowDefinitionsQuerySchema.strict(),
    response: z.array(FlowDefinitionForListSchema),
};
export const FlowDefinitionGetRoute = {
    method: 'get',
    fullPath: `${FLOW_DEFINITIONS_BASE_ROUTE}/:id`,
    summary: 'Get a flow definition by id',
    description: 'Returns the complete saved flow definition the caller can access, including its block graph and configuration. Use this to inspect or validate a flow before deployment.',
    tags: TAGS,
    params: GetFlowDefinitionByIdParamsSchema.strict(),
    response: FlowDefinitionWithFlowSchema,
};
export const FlowDefinitionUpdateRoute = {
    method: 'patch',
    fullPath: `${FLOW_DEFINITIONS_BASE_ROUTE}/:id`,
    summary: 'Update a flow definition',
    tags: TAGS,
    params: z.strictObject({ id: z.string() }),
};
//# sourceMappingURL=routes.js.map